import * as apiDelete from 'api/productionMethod/DeleteProductionMethodIdV1';
import * as apiRestore from 'api/productionMethod/PostProductionMethodRestoreV1';
import * as apiPostSearch from 'api/productionMethod/PostProductionMethodSearchV1';

export default class ProductionMethod {
	public id: string = '';
	public name: string = '';

	public constructor(input?: apiPostSearch.ResponseProductionMethod) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiDelete(): Promise<void> {
		await apiDelete.callApi(this.id);
	}

	public async callApiRestore(): Promise<void> {
		await apiRestore.callApi(this.id);
	}

	private mapFromApi(input: apiPostSearch.ResponseProductionMethod) {
		this.id = input.id;
		this.name = input.name;
	}
}
